<div class="d-block">
  <!--<div class="d-flex justify-content-end" *ngIf="assetService.selectedRepository.id">
    <button class="btn btn-danger" (click)="assetService.deleteRepository(assetService.selectedRepository)">
      <sb-icon icon="trash"></sb-icon>
    </button>
  </div>
  -->
  <label class="form-label" for="name">{{ 'lang.globals.name' |translate }}</label>
  <input id="name" name="name" class="form-control" [(ngModel)]="assetService.selectedRepository.name">
  <label class="form-label mt-2" for="validity">{{ 'lang.globals.validity' |translate }}</label>
  <sb-local-date-range-input id="validity" class="mr-2"
                             [today]="null"
                             [from]="assetService.selectedRepository?.shareStart"
                             [till]="assetService.selectedRepository?.shareEnd"
                             (dateChange)="assetService.handleDateChangeRepositories($event)"></sb-local-date-range-input>

  <div class="my-2">{{ 'lang.globals.sharedWith'|translate }}</div>
  <sb-comp-selection [display]="assetService.selectedRepository?.clientCull"
                     (selectClicked)="assetService.selectClientCull()"
                     (createClicked)="assetService.createClientCull()"
                     (deleteClicked)="assetService.deleteClientCull()">
  </sb-comp-selection>
  <!--  </ng-container>
    <ng-container *ngIf="!editable">
      {{repo?.clientCull ? repo?.clientCull?.name : '-' }}
    </ng-container>
  </div>
  -->
  <ng-container *ngIf="assetService.selectedRepository?.createdAt">
    <div>{{ 'lang.globals.modifiedAt' | translate }}</div>
    <sb-comp-display-created [data]="assetService.selectedRepository"></sb-comp-display-created>
  </ng-container>
</div>
<div class="d-flex justify-content-end mt-4">
  <button (click)="assetService.updateRepository(assetService.selectedRepository)" [disabled]="!assetService.selectedRepository?.name"
          class="btn btn-primary">
    <sb-icon icon="save"></sb-icon>
    {{ 'lang.globals.save' |translate }}
  </button>
</div>
